import { sendVerificationSms } from "../../../actions/login/sendVerificationSms";
import { encode } from "../../../helpers/queryEncryption";
import { clientSmsKey } from "../../../helpers/clientSmsKey";
import showToaster from "../../../helpers/toastrMessgaes/showToaster";

async function submit(values, dispatch) {

    if (!values.isAgreePhoneNumberVerification) {
        showToaster({ toasterType: 'error', messageId: 'isAgreePhoneNumberError' });
        return;
    }

    let phoneDialCode, phoneNumber, userType = 1, jwtToken = encode(clientSmsKey);
    phoneDialCode = values?.phoneDialCode, phoneNumber = values?.phoneNumber;

    values?.phoneNumber && await dispatch(sendVerificationSms({ phoneDialCode, phoneNumber, userType, jwtToken }));
}

export default submit; 